/* eslint-disable no-unused-vars */
import * as React from 'react';
import {Button,Grid, TextField} from '@mui/material';
import {PersonOutline} from '@material-ui/icons';
import useStyles from './styles';
import CommentItem from './commentitem/CommentItem'
import {axiosClient,config} from '../../../services/axiosClient';

/* const blue = {
    200: '#80BFFF',
    400: '#3399FF',
  };
  
  const white = {
      200: '#FFF',
      400: '#FFFEE',
    };
  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };
  
  const StyledInputElement = styled('input')(
    ({ theme }) => `
    width: 100%;
    height:35px;
    font-size: 0.875rem;
    font-family: IBM Plex Sans, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[300]};
    border-radius: 10px;
    padding: 12px 12px;
    transition: all 150ms ease;
  
    &:hover {
      background: ${theme.palette.mode === 'dark' ? null : grey[100]};
      border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[400]};
    }
  
    &:focus {
      outline: 2px solid ${theme.palette.mode === 'dark' ? white[400] : white[200]};
    }
  `
  );
  
  const CustomInput = React.forwardRef(function CustomInput(props, ref) {
    return (
      <InputUnstyled  components={{ Input: StyledInputElement }} className={props.className} placeholder={props.placeholder} ref={ref} value={props.commentText} onChange={(e)=>{props.handleoninputchange(e.target.value)}}/>
    );
  }); */
    
const Comments = ({userid,user,order,ratedValue,setMessage,setOpenSnackBar,rateStore,rateProduct,updateAppcredits}) => {

   const [commentText,setCommentText]=React.useState('');
   const [comments,setComments]=React.useState([]);
   const [username,setUsername]=React.useState('')
   const classes=useStyles();
   
   
   const handleoninputchange=(e)=>{
    setCommentText(e.target.value);
  }
 
   const handleAddComment = async ()=>{
    console.log(ratedValue)
    
    if (ratedValue > 0){
           if (commentText!=='') {
            addComment().then((response)=>{
             console.log(response)
            if (response.status===200){
              setComments([...comments,response.data.comment]);
              setCommentText('');
             //rateStore(order.storeId,ratedValue)
             rateProduct(order.productId,order.storeId,ratedValue)
             updateAppcredits(2,'comments')
            }
          })}else{
            setMessage({body:'Please type in review to send ',severity:'info'})
            setOpenSnackBar(true)
          }
        }else{
          setMessage({body:'Please rate product',severity:'info'})
          setOpenSnackBar(true)
        }
   }

   const addComment = async ()=>{
   
     const url=`${process.env.REACT_APP_SERVER_URL}/comments/`;
      return  axiosClient.post(url,{productid:order.productId,storeid:order.storeId,text:commentText,username:username},config);
   }
   
   React.useEffect(()=>{
    try{
    //  var userObj =JSON.parse(localStorage.getItem('user'));
      let loggedin=localStorage.getItem('loggedin');
      if(loggedin ==='true'){  
        const userObj = JSON.parse(localStorage.getItem('user'));
        const user=userObj.user
       setUsername(user.username)    
      }else{
       setUsername('Guest')    
      }
    }catch(err){
     console.log(err)
    }
     const handlegetComments = async() =>{
         loadCommentsFromServer().then((response)=>{
           if(response.status===200){
             setComments(response.data.comments)
           }
         })
     }
      const loadCommentsFromServer= async ()=>{
        const url=`${process.env.REACT_APP_SERVER_URL}/comments/${order.storeId}/${order.productId}`;
       return axiosClient.get(url,{},config)
      }

      handlegetComments();
    },[order, user.name])
  return (
    <Grid container justifyContent='space-between' direction='column' className={classes.root}>
        <Grid xs={12} item className={classes.commentList}>
         <Grid container justifyContent='space-between' >
         {
           comments.map((comment,index)=>{
             return(
               <Grid item xs={12}>
                  <CommentItem comment={comment} key={index}/>
               </Grid>
             )
           })
         }
         </Grid>
        </Grid>

        <Grid  item className={classes.inputactions} marginTop={1}>
          <Grid container justifyContent='flex-start'  spacing={0.5}>
             <Grid item xs={9.5} >
             <TextField variant='outlined'
             sx={{border:'3px darkgray', backgroundColor: 'white', "& .MuiOutlinedInput-input": {
              borderWidth: 0,
              width:'100%',
              /*width: showTextfield ? '100%' : 0,*/
              outline: "none",
              padding: 0.6, 
              paddingLeft:2,
            /*transition:' width 2s',*/
              float:'right'

  },'& .MuiOutlinedInput-root': {
		'& fieldset': {
		/* borderColor: 'var(--app-font-darkgray)',
		  borderRadius: '18px', */
		 '&:hover fieldset': {
            borderColor: 'green',
          },
          '&.Mui-focused fieldset': {
             borderColor: 'green',
          },//fxSQrcwXHsG@S74 mongo
		},
	},
}}
             className={classes.textinput} aria-label="comment input" placeholder="Type in to add feed back" value={commentText} onChange={(e)=>{handleoninputchange(e)}} />
             </Grid>
             <Grid item xs ={1}>
             <Button   className='client-action-Button' color='primary' variant='contained' onClick={()=> {handleAddComment()}}>send</Button>
             </Grid>
          </Grid>
       
       
        </Grid>
      </Grid>
  )
}

export default Comments
